const config = {
  wallet_url: 'https://api-wallet.octoex.com/client',
  apiEncKey: '6f7c5d95-7535-470c-a701-5e0d23966896',
}

export default config
